<form id="store_filters" [formGroup]="this.filtersStoreForm" (ngSubmit)="this.search()">
    
    <div id="store_filters_list">
        <app-retailer-select label="{{ 'RETAILERS' | translate }}" formName="retailersCodes" [withSpeechToText]="true" [multiple]="true" />                       
        <app-store-select label="{{ 'STORES' | translate }}" formName="storesCodes" [stores]="this.stores" [withSpeechToText]="true" [multiple]="true" />                           
        <marv-input type="text" label="{{ 'CITY' | translate }}" icon="business-outline" formName="city" [showBtnClearInput]="true" [withSpeechToText]="true"/>                    
        <app-area-select label="{{ 'AREAS' | translate }}" formName="areasIds" [withSpeechToText]="true" [multiple]="true" />                       
        <app-sector-select label="{{ 'SECTORS' | translate }}" formName="sectorsIds" [sectors]="this.sectors" [withSpeechToText]="true" [multiple]="true" />                     
        <app-operation-select label="{{ 'WITH_COMMAND_OPERATION' | translate }}" [withSpeechToText]="true" formName="withOperationId" />               
        <app-operation-select label="{{ 'WITHOUT_COMMAND_OPERATION' | translate }}" [withSpeechToText]="true" formName="withoutOperationId" />                      
    </div>
    
    <ion-grid id="footer_store_filters">
        <ion-row class="ion-justify-content-around">
            <ion-col size="auto">
                <marv-button type="submit" label="{{ 'SEARCH' | translate }}" icon="search-outline" color="primary" />
            </ion-col>
            <ion-col size="auto">
                <marv-button type="button" label="{{ 'DISPLAY_ALL' | translate }}" icon="refresh-outline" color="secondary" (click)="this.displayAll()" />
            </ion-col>
        </ion-row>
    </ion-grid>
    
</form>